import React from 'react';
import ReactMarkdown from 'react-markdown';
import {Container, Typography, Paper, Box} from '@mui/material';
import UserDanceTable from "../users_list/UserDanceTable";

const articleContent = `
# Судейство Boogie-Woogie

Судейство Boogie-Woogie имеет общепринятую мировую схему и описано в официальных документах на сайте WRRC: [WRRC Boogie-Woogie Rules](https://wrrc.dance/rules/boogie-woogie-rules/)

Поскольку процесс подсчета оценок довольно сложен и может быть непонятен для обычного зрителя, в этом материале я постараюсь раскрыть все его секреты.

## Ключевые сущности

1. **Судейские карточки**
2. **Итоговые баллы**

### Судейские карточки

Судьи оценивают выступление по пяти критериям:

1. **Базовая техника основного хода партнера (Basics Man)** — 5 очков/7.5 баллов
2. **Базовая техника основного хода партнерши (Basics Woman)** — 5 очков/7.5 баллов
3. **Ведение-следование, базовые фигуры, гармония в паре, представление (Lead & Follow, Basic Dancing, Harmony, Performance)** — 10 очков/15 баллов
4. **Танцевальные фигуры и чистота их исполнения (Dance Figures, Execution)** — 10 очков/10 баллов
5. **Музыкальность (Music Interpretation)** — 10 очков/25 баллов

Значения через тире обозначают:
- Максимальные очки в карточке судьи / Максимальный балл в итоговой оценке**


## Процесс подсчета баллов

Чтобы понять, как формируется финальный результат, рассмотрим процесс по шагам:

### 1. Перевод судейских карточек в баллы

Применяется формула:
(судейский критерий * максимальное количество баллов) / максимальное значение критерия в карточке

### 2. Определение медианы

По каждому критерию вычисляется медиана оценок всех судей.

### 3. Расчет разницы

Для каждого критерия и судьи вычисляется разница между медианой и оценкой судьи.

### 4. Определение коэффициента судьи

Используется формула:
1 / (1 + (difference * difference))

### 5. Масштабирование оценок

Баллы корректируются с учетом коэффициента:
ball * coefficient

### 6. Суммирование коэффициентов

По каждому критерию складываются все коэффициенты.

### 7. Суммирование масштабированных оценок

По каждому критерию складываются скорректированные баллы.

### 8. Вычисление средней оценки по критерию

Применяется формула:
сумма(scaled marks) / сумма(coefficient)

### 9. Подсчет общего балла

Итоговая сумма всех критериев формирует общий балл за раунд (fast или slow).


## Итоговый балл

Если соревнование включает два типа заходов (fast и slow), итоговый балл рассчитывается так:
(((fast + 10%) + slow)*65)/136.5

Однако если в турнире присутствует **Hope Round** (тур надежды), то все предыдущие баллы аннулируются, и в финал проходят только участники с наивысшими баллами Hope Round.


## Пример расчета

**Оценки судей:**
\`\`\`
2.5 | 2.5 | 6.0 | 6.0 | 6.0
3.5 | 3.5 | 7.5 | 8.5 | 8.5
3.0 | 2.5 | 7.5 | 5.5 | 8.0
4.5 | 4.5 | 8.5 | 8.5 | 8.5
2.0 | 2.0 | 4.5 | 6.5 | 6.0
\`\`\`

**Общий итог:**
fast: 50.92 + slow: 42.42 → 44.44 - Этот балл определяет место участника в соревновании.

**Дополнительные ссылки по теме**

[Система судейства BW в RSC от 2024 года](https://docs.google.com/document/u/1/d/1JulAiSBFPz_uXI28kPMQqcHnU0EKZ8XN/mobilebasic)



`;

const ArticlePage = () => {
    return (
        <Box  sx={{
            overflow: 'auto',
            width: '100%',
            mt: 0,
            p: 5,
            background: '#80808040',
            height: (window.innerHeight - 50) + 'px'
        }}>
            <ReactMarkdown>
                {articleContent}
            </ReactMarkdown>
        </Box>
    );
};

export default ArticlePage;